import { defineComponent as _defineComponent } from 'vue'


// Components
import PackageDetalisPopUp from "./packageDetalisPopUp.vue"

// Props
interface Props {
	top?: string
	left?: string
	additionalClasses?: string[]
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PackageDetailsTooltip',
  props: {
    top: null,
    left: null,
    additionalClasses: null
  },
  emits: ["click"],
  setup(__props: any, { emit }: { emit: ({
	(event: "click"): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	top?: string
	left?: string
	additionalClasses?: string[]
};



 // Strongly type the emitted event

const handleClick = (): void => {
	emit("click")
}

return { __sfc: true,props, emit, handleClick, PackageDetalisPopUp }
}

})